import { useRoutes } from 'hookrouter';
import React from 'react';

import { NotFoundPage } from './pages/NotFound';
import { routes } from './routes';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function App(props: { basePath: string }) {
  const routeResult = useRoutes(routes);

  return routeResult ? <React.StrictMode>{routeResult}</React.StrictMode> : <NotFoundPage />;
}

export default App;
